import { PLAN_TIER } from '@app/constant/plan-tier';

export function userHasPlusTier(user) {
  return user.planTier === PLAN_TIER.PLUS;
}

export function userHasFreeTier(user) {
  return user.planTier === PLAN_TIER.FREE;
}

export function isLoggedInPlusUser(user) {
  return user.loggedIn && userHasPlusTier(user);
}

export function isLoggedInFreeUser(user) {
  return user.loggedIn && userHasFreeTier(user);
}
